import { api } from "@/api";
import {
  AllowedDefaultModelsResponse,
  extractAllModelNames,
  ModelNamesByCategory,
} from "@/types/modelConfig";
import { useEffect, useState } from "react";

export function useAllowedModels() {
  const [data, setData] = useState<AllowedDefaultModelsResponse | null>(null);
  const [modelNames, setModelNames] = useState<ModelNamesByCategory | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        setLoading(true);
        const response = await api.request<AllowedDefaultModelsResponse>({
          path: "/api/v1/agent/configs/allowed-default-models",
          method: "GET",
        });
        setData(response.data);
        setModelNames(extractAllModelNames(response.data));
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to fetch models")
        );
      } finally {
        setLoading(false);
      }
    };

    void fetchModels();
  }, []);

  return { data, modelNames, loading, error };
}
